
const MTips = {
    roleErrorMsg: "Sorry, you don’t have permission to create a patient group. Please contact clinic administrator if you need further assistance.",
}

export {
    MTips,
}
